import utils from "@/components/declarations/validators/utils";

export default {
  isValid(self, isDraft) {
    const errors = {
      atLeastOne: false,
      sourceOfHeatLength: false,
      sourcesOfHeats: self.heatSources.map((el) => {
        return {
          type: false,
          amount: false,
          usedAmount: false,
          anyHeating: false
        }
      })
    };

    self.setErrors(errors);

    let text = "";

    if (!isDraft && !self.heatSources.length) {
      errors.sourceOfHeatLength = true;
      text += "Brak możliwości przejścia dalej ze względu na brak wyboru źródła ciepła. <br/>";
      errors.atLeastOne = true;
    }

    self.heatSources.forEach((hs, index) => {
      if (!hs.type.id) {
        errors.sourcesOfHeats[index].type = true;
        errors.atLeastOne = true;
        text += "Prosimy o wybranie rodzaju źródła ciepła zainstalowanego budynku <br/>";
      }

      if (isNaN(parseInt(hs.amount)) || parseInt(hs.amount) <= 0) {
        errors.sourcesOfHeats[index].amount = true;
        errors.atLeastOne = true;
        text += "Prosimy o podanie liczby źródeła ciepła zainstalowanych budynku <br/>";
      }

      if (hs.isUsed && (isNaN(parseInt(hs.usedAmount)) || parseInt(hs.usedAmount) <= 0 || parseInt(hs.usedAmount) > hs.amount)) {
        text += "Wprowadzono niepoprawną liczbę używanych źródeł ciepła <br/>";
        errors.sourcesOfHeats[index].usedAmount = true;
        errors.atLeastOne = true;
      }

    });

    if (errors.atLeastOne) {
      utils.showMessage(self, text);
    }
    return errors;
  }
}
